
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.52984 7.52941C9.60903 7.52941 11.2945 5.8439 11.2945 3.76471C11.2945 1.68552 9.60903 0 7.52984 0C5.45065 0 3.76514 1.68552 3.76514 3.76471C3.76514 5.8439 5.45065 7.52941 7.52984 7.52941Z"}}),_c('path',{attrs:{"d":"M15.0588 14.1178V15.0589C15.0588 15.3086 14.9597 15.5479 14.7832 15.7245C14.6067 15.901 14.3673 16.0001 14.1176 16.0001H0.941176C0.691561 16.0001 0.452169 15.901 0.275664 15.7245C0.0991596 15.5479 0 15.3086 0 15.0589V14.1178C0 12.6201 0.594956 11.1837 1.65399 10.1247C2.71301 9.06566 4.14937 8.4707 5.64706 8.4707H9.41176C10.9095 8.4707 12.3458 9.06566 13.4048 10.1247C14.4639 11.1837 15.0588 12.6201 15.0588 14.1178Z"}})])
          )
        }
      }
    